import TrainingExtraCard from './TrainingExtraCard';

export default TrainingExtraCard;
